$(document).ready(function() {
	if(!$('.slider-overlay').length){
		$('body').append(`
			<div class="slider-overlay">
				<div class="content">
					<a href="#" class="closebtn">&times;</a>
					<a href="#" class="navbtndownload">&#10515;</a>
					<a class="navigationControls prev">&#10094;</a>
					<a class="navigationControls next">&#10095;</a>
					<img src="" class="img-responsive bigImage"/>
					<div class="slider-title"></div>
				</div>
			</div>
		`)
	}

	/**
	 * [showOverlay : method to show overlay]
	 */
	function showOverlay() {
		$('.slider-overlay').fadeIn('slow');
	}

	/**
	 * [hideOverlay : method to hide overlay]
	 */
	function hideOverlay() {
		$('.slider-overlay').fadeOut('slow');
	}

	let currentIndex = 0;


	//Event handler for image link when clicked
	$(document).on('click','.quick-slider',function(e){
		e.preventDefault();
		console.log('SLIDER CLICK')
		let stringData = $(this).closest('.slider').attr('data-slider');
		$('.slider-overlay').attr('data-slider', stringData)
		images = JSON.parse(stringData);
		showOverlay();
		currentIndex = 0;
		var imgSrc = url+'/storage/'+images[currentIndex];

		$('.bigImage').attr('src', imgSrc).on('load', function() {
			$(this).fadeIn('slow');
		});

		// Show/hide navigation controls based on the number of images
		updateNavigationControls(images.length, currentIndex);

		return false;
	});

	//Event handler for close button on overlay to close it
	$(document).on('click', '.closebtn', function(event) {
		event.preventDefault();
		hideOverlay();
	});

	$(document).keyup(function(e) {
		if($('.quick-slider').length){
			if (e.keyCode == 39) {
				$('.navigationControls.next').trigger('click')
			}
			if (e.keyCode == 37) {
				$('.navigationControls.prev').trigger('click')
			}
			if (e.keyCode == 27) {
				hideOverlay();
			}
		}
	});

	$(document).on('click','.slider-overlay',function(e){
		// if clcked outside image or downlooad button hide
		if($(e.target).hasClass('bigImage') || $(e.target).hasClass('navbtndownload')){
			return false;
		}
		hideOverlay();
	});

	$(document).on('click','.navigationControls',function(e){
		e.preventDefault();
		images = JSON.parse($(this).closest('.slider-overlay').attr('data-slider'));
		var totalImages = images.length;

		// Update the current index before setting the image source
		if($(this).hasClass('prev')){
			if(currentIndex > 0){
				currentIndex--;
			}
		}else{
			if(currentIndex < totalImages - 1){
				currentIndex++;
			}
		}

		console.log("loading", currentIndex, images[currentIndex])

		$('.bigImage').attr('src', url+'/storage/'+images[currentIndex]).on('load', function() {
			$(this).fadeIn('slow');
		});

		// Show/hide navigation controls based on the current index
		updateNavigationControls(totalImages, currentIndex);

		return false;
	});

	// Function to update navigation controls visibility
	function updateNavigationControls(totalImages, currentIndex) {
		if(totalImages === currentIndex + 1){
			$('.navigationControls.next').hide();
			console.log('NEXT HIDE')
		}else{
			$('.navigationControls.next').show()
		}

		if(currentIndex === 0){
			$('.navigationControls.prev').hide();
			console.log('PREV HIDE')
		}else{
			$('.navigationControls.prev').show()
		}
	}


	function compressAndSaveImage(imageUrl, callback) {
		// Create a new canvas element
		var canvas = $('<canvas/>')[0];
		var ctx = canvas.getContext('2d');

		// Load the image
		var img = $('<img/>')[0];
		img.src = imageUrl;
		img.onload = function() {
		  // Get the image dimensions
		  var width = img.width;
		  var height = img.height;

		  // Compress the image to less than 200KB
		  canvas.width = width;
		  canvas.height = height;
		  ctx.drawImage(img, 0, 0, width, height);
		  var dataURL = canvas.toDataURL('image/jpeg', 0.5);

		  // Check if the compressed size is less than 200KB
		  var compressedSize = dataURL.length * 3 / 4;
		  if (compressedSize < 200 * 1024) {
			// Save the compressed image
			var blob = dataURLToBlob(dataURL);
			saveAs(blob, Date.now() + '_compressed.jpg');
			callback(true);
		  } else {
			callback(false);
		  }
		};
	  }

	  // Helper function to convert data URL to blob
	  function dataURLToBlob(dataURL) {
		var bytes = dataURL.split(',')[1];
		var mime = dataURL.split(',')[0].split(':')[1].split(';')[0];
		var binary = atob(bytes);
		var arrayBuffer = new ArrayBuffer(binary.length);
		var uint8Array = new Uint8Array(arrayBuffer);
		for (var i = 0; i < binary.length; i++) {
		  uint8Array[i] = binary.charCodeAt(i);
		}
		return new Blob([arrayBuffer], { type: mime });
	  }

	  // Helper function to save blob as file
	  function saveAs(blob, filename) {
		var link = document.createElement('a');
		link.href = URL.createObjectURL(blob);
		link.download = filename;
		link.click();
	  }

	  $(document).on('click', '.navbtndownload', function(){
		var elem = $(this).parent('.content').find('img').attr('src');
		compressAndSaveImage(elem, function(compressed) {
			// ...
		})
	  });
}); //document ready ends here
